import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CarrierProductsDrawer from './CarrierProductsDrawer';

import { BorderRadius, Colors, FontSizes } from '../Theme';

const CarrierCard = ({
  carrier,
  isSelected,
  lineOfBusiness,
  onProductsSave,
  onClick,
  products,
  selectedProductIds
}) => {
  const [is_hover, setHover] = useState(false);
  const [show_product_modal, setProductModal] = useState(false);
  const styles = {
    carrier: {
      width: '18%',
      minWidth: 210,
      border: '1px solid #e5e5e5',
      borderRadius: BorderRadius.DEFAULT,
      margin: '0 1% 2%',
      boxShadow: is_hover ? '0px 2px 3px rgba(0,0,0,0.1)' : 'none'
    },
    top: {
      padding: '30px 10px',
      overflow: 'hidden',
      cursor: 'pointer',
      position: 'relative',
      background: '#fff',
      borderTopLeftRadius: BorderRadius.DEFAULT,
      borderTopRightRadius: BorderRadius.DEFAULT
    },
    logo: {
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: 50
    },
    details: {
      borderTop: '1px solid #e5e5e5',
      lineHeight: '1.3em',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      height: 60
    },
    name: {
      padding: 10,
      width: selectedProductIds && onProductsSave ? '80%' : '100%'
    },
    filter: {
      width: '20%',
      cursor: 'pointer',
      padding: '0 5px',
      borderLeft: '1px solid #e5e5e5',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    filter_icon: {
      fontSize: 22,
      color: Colors.PRIMARY.hex
    },
    logo_hover: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: isSelected ? 'rgba(170, 170, 170, 0.9)' : 'rgba(100, 100, 100, 0.9)',
      borderRadius: `${BorderRadius.DEFAULT}px ${BorderRadius.DEFAULT}px 0 0`,
      textAlign: 'center',
      color: '#fff',
      fontWeight: 500,
      fontSize: FontSizes.SMALL,
      transform: !isSelected || is_hover ? 'translateY(0%)' : 'translateY(-100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    icon: {
      fontSize: 45,
      margin: '20px 0 5px',
      color: '#fff'
    }
  };

  useEffect(() => {
    if (!show_product_modal) {
      document.body.classList.remove('ixn-no-scroll');
    }
  }, [show_product_modal]);

  const handleFilterClick = () => {
    setHover(false);
    setProductModal(true);

    setProductModal(isSelected);
    setHover(!isSelected);
  };

  return (
    <div
      onMouseEnter={setHover.bind(null, true)}
      onMouseLeave={setHover.bind(null, false)}
      style={styles.carrier}
    >
      {show_product_modal ? (
        <CarrierProductsDrawer
          carrier={carrier}
          carrierName={carrier.name}
          isSelected={isSelected}
          lineOfBusiness={lineOfBusiness}
          onChange={onProductsSave}
          onClose={setProductModal.bind(null, false)}
          products={products}
          selectedProductIds={selectedProductIds}
        />
      ) : null}
      <div onClick={onClick} style={styles.top}>
        <div style={{ backgroundImage: `url(${carrier.logo.url})`, ...styles.logo }} />
        <div style={styles.logo_hover}>
          <div>
            <i
              className={`mdi mdi-${isSelected ? 'minus-circle' : 'plus-circle'}`}
              style={styles.icon}
            />
            <div>{isSelected ? 'Click To Remove' : 'Click To Add'}</div>
          </div>
        </div>
      </div>
      <div style={styles.details}>
        <div style={styles.name}>{carrier.name}</div>
        {selectedProductIds && onProductsSave && isSelected ? (
          <div onClick={handleFilterClick} style={styles.filter}>
            <i className='mdi mdi-tune' style={styles.filter_icon} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

CarrierCard.propTypes = {
  carrier: PropTypes.object,
  closedModal: PropTypes.bool,
  isSelected: PropTypes.bool,
  lineOfBusiness: PropTypes.string,
  onClick: PropTypes.func,
  onProductsSave: PropTypes.func,
  products: PropTypes.array,
  selectedProductIds: PropTypes.array
};

export default CarrierCard;
